Apt.fn.make('account.notifications', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;

		LS.api.get('me/notifications', {
			auth: true,
			success: data => {
				priv.make(data.results);
			}
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('notifications', this.$private, 'app');
	}
}, {
	/**
	 * @private
	 */
	_construct() {
		this.model = [
			{
				key: 'saved_searches',
				label: 'Saved searches',
				caption: 'Disable all saved search notifications'
			},
			{
				key: 'saves',
				label: 'Saved listing updates',
				caption: 'Updates on all of your saved properties'
			},
			{
				key: 'general',
				label: 'General newsletter',
				caption: 'Occasional tips, updates, and industry news'
			},
			{
				key: 'featured',
				label: 'Featured listings',
				caption: 'Relevant property and agent recommendations'
			},
			{
				key: 'listing_reports',
				label: 'Listing reports',
				caption: 'Periodic status report of your own properties'
			}
		];
	},

	/**
	 * Create the notifications application
	 *
	 * @param {Object} results
	 */
	make(results) {
		const scope = this;

		scope.model.forEach(notification => {
			notification.status = results[notification.key];
		});

		scope.app = $.app.make('notifications', {
			view: $$('template')[0].textContent,
			target: '$notifications',
			model: {
				results: scope.model
			}
		});

		scope.bind();
	},

	/**
	 * Bind application events
	 */
	bind() {
		const scope = this;

		$$('toggle').on('change', () => {
			scope.save();
		}, {
			namespace: 'notifications'
		});
	},

	/**
	 * Save notification update
	 */
	save() {
		const data = {};

		$('$toggle', '$notifications')
			.each(el => {
				data[el.id] = el.checked ?
					'1' : '0';
			});

		LS.api.request('me/notifications', {
			auth: true,
			method: 'patch',
			data: data
		});
	}
});